<template>
  <div>
    <form class="input-group mb-3" @submit.prevent="geocode()">
      <input type="text" class="form-control" v-model="address" placeholder="An address to geocode" aria-label="Address">
      <div class="input-group-append">
        <button class="btn btn-primary" type="submit" :disabled="geocoding">
          <i v-if="!geocoding" class="fa fa-globe mr-1"></i>
          <i v-if="geocoding" class="fa fa-circle-o-notch fa-spin mr-1"></i>
          Geocode
        </button>
      </div>
    </form>
    <div class="card mb-2" v-for="result in geocoded">
      <div class="card-body">
        <h3 class="h4 mb-0">{{ result.address }}</h3>
        <div class="text-muted">{{ result.place_id }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    api: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      geocoded: [],
      geocoding: false,
      address: null
    }
  },
  methods: {
    geocode () {
      if (this.geocoding) {
        return false
      }
      this.geocoding = true
      let address = this.address
      this.address = ''

      axios.post(this.api, { address })
        .then((response) => {
          this.geocoded.unshift(response.data)
          this.geocoding = false
        })
    }
  }
}
</script>